import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux'
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import { Paginator } from 'primereact/paginator';
import { deleteSMD } from '../Actions/SMDlistingAPI';
import { confirmAlert } from 'react-confirm-alert';
import { DownloadAttachment } from '../Actions/AttachmentAPI';
import swal from "sweetalert"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { css } from "glamor";
toast.configure();
class SMDCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            first: 0,
            rows: 10,
            pageNumber: 0,
            searchDate: { companyname: '', pagenumber: '', pagesize: 10 }
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch } = nextProps;
        if (nextProps.ResetSMD === true) {
            prevState.first = 0
            prevState.pageNumber = 0
            dispatch({ type: "ResetSMD", data: false })
        }
    }
    render() {
        const { arraylist, pageSize } = this.props;
        return (
            <div className="">
                {this.renderCardData()}
                {arraylist.count != 0 ?
                    <Paginator first={this.state.first} rows={pageSize} totalRecords={(arraylist.count) ? arraylist.count : 0} onPageChange={(e) => this.onPaginatorChange(e)}></Paginator> :
                    <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                        <div class="container">
                            <h6 className="resource-list-title no-item-card">!--No Item to Display--!</h6>
                        </div>
                    </div>}
            </div>
        );
    }
    onPaginatorChange(event) {
        this.setState({
            first: event.first,
            pageNumber: event.page
        });
        const { setUpdatedState } = this.props;
        setUpdatedState(event.page + 1);

    }
    downloadAttachment(data) {
        const { dispatch } = this.props;
        dispatch(DownloadAttachment(data));
    }
    SMDEditItem = (editData) => {
        this.props.dispatch({ type: 'IsSMDEdit', data: editData });
        this.props.history.push(`/Home/SMDEditItem/${editData.supplierMaterialDeclarationId}`);
    }

    DeletePopup(id) {
        confirmAlert({
            message: 'Are you sure want to delete ?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        this.DeleteItem(id)
                    }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
        }

    DeleteItem = (id) => {
        const { dispatch } = this.props;
        dispatch(deleteSMD(id));
    }

    renderCardData = () => {
        const { arraylist, IsSMDEdit } = this.props;
        return arraylist['supplierMaterialDeclarations'] && arraylist['supplierMaterialDeclarations'].length
            ? arraylist['supplierMaterialDeclarations'].map((item, index) => {
                return (
                    <div className="card resource-list-auth-date" style={{ overflow: "hidden", position: "relative" }}>
                        <div className="row">
                            <div className="col-md-1 col-sm-2 col-2">
                                <div className="" style={{ color: 'white', background: '#1E3A8A', height: "100%", width: "100%", textAlign: "center" }}>
                                    <h1 style={{ color: "#fff", height: "100%" }} className={"italicFont mb-0"}>{(index + 1) + (this.state.pageNumber * (10))}</h1>
                                </div>
                            </div>
                            <div className="col-md-10 col-sm-9 col-9">
                                <div className="row">
                                    <div className="col-md-5 col-sm-4 m-auto">
                                        <span><strong>Company Name: </strong><span className="italicFont ">{item.companyName}</span></span>
                                    </div>
                                    <div className="col-md-4 col-sm-4 m-auto" >
                                        <span>
                                            <strong>File: </strong>
                                            <span className="italicFont"> {item.attachmentName}</span>
                                        </span>
                                    </div>
                                    <div className="col-md-3 col-sm-4 col-m-auto">
                                        <div className="text-center ml-4">
                                            <i className="fa fa-download fa-lg fa-2x p-2 click" onClick={() => this.downloadAttachment(item)} style={{ color: " #1E3A8A" }}></i>
                                            <i class="fa fa-edit fa-2x p-2 fa-lg click" onClick={() => this.SMDEditItem(item)} style={{ color: " #1E3A8A" }}></i>
                                            <i class="fa fa-trash fa-2x p-2 click" aria-hidden="true" onClick={() => this.DeletePopup(item.supplierMaterialDeclarationId)} style={{ color: " #1E3A8A" }}></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }) : null;
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        IsSMDEdit: state.SidePanReducer.IsSMDEdit,
        ResetSMD: state.SidePanReducer.ResetSMD
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SMDCard));